import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import RedirectToLogin from '@sprinx/react-auth/RedirectToLogin';
import RouteContent from '../internal/RouteContent';

var _ref2 = React.createElement(RedirectToLogin, null);

function PrivateRouteContent(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
      rest = _objectWithoutProperties(_ref, ["isAuthenticated"]);

  return !isAuthenticated ? _ref2 : React.createElement(RouteContent, rest);
}

PrivateRouteContent.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired
};
export default PrivateRouteContent;